const fileTypes = {
    'image/png': { type: 'PNG', mime: 'image/png', signatures: [[0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]] },
    'image/jpeg': { type: 'JPG/JPEG', mime: 'image/jpeg', signatures: [[0xff, 0xd8, 0xff]] },
    'image/svg+xml': { type: 'SVG', mime: 'image/svg+xml', patterns: ['<?xml', '<svg', 'http://www.w3.org/2000/svg'] },
};

export const verifyFileMimeType = async (file) => {
    const mimeType = file.type;
    const maxBufferSize = 2048;
    const arrayBuffer = await file.slice(0, maxBufferSize).arrayBuffer();
    const bytes = new Uint8Array(arrayBuffer);

    const type = fileTypes[mimeType];

    if (!type) return { status: false, msg: "Invalid mimetype. Only PNG, JPG, and SVG are allowed." };

    const { signatures, validate } = type;

    if (signatures && signatures.some((sign) => {
        const start = 0;
        return sign.every((byte, i) => bytes[start + i] == byte)
    })) {
        return { status: true, msg: "" };
    }

    if (validate) {
        const text = new TextDecoder('utf-8', { fatal: false }).decode(arrayBuffer).toLowerCase();
        const result = validate(text);
        return { status: result.status, msg: result.msg };
    }

    // For SVG, we might want to do a simple text check if no signature
    if (mimeType === 'image/svg+xml') {
        const text = new TextDecoder('utf-8', { fatal: false }).decode(arrayBuffer).toLowerCase();
        if (text.includes('<svg')) {
            return { status: true, msg: "" };
        }
    }

    return { status: false, msg: "Invalid file content for the selected mimetype." };
};
